<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
import MaterialRequestsAdminList from '@/components/page-publisher-material-requests/MaterialRequestsAdminList.vue';
import { promiseAll, calculatePromise } from '@/api/default.js';
import constants from '@/constants';

export default {
    name: 'PublisherMaterialRequestsAdminPage',

    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        MaterialRequestsAdminList,
    },

    computed: {
        constants() {
            return constants;
        },
        statusFilters() {
            return this.$store.getters.ADMIN_MATERIAL_REQUESTS_FILTERS;
        },
    },

    async mounted() {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                '[PublisherMaterialRequestsAdminPage.mounted] Initialising page'
            );
        }

        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            {
                dispatch: 'loadAdminMaterialRequests',
                commit: null,
                isArray: false,
            },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);

        if (process.env.NODE_ENV !== 'production') {
            console.info(
                '[PublisherMaterialRequestsAdminPage.mounted] Page ready'
            );
        }
    },

    methods: {
        async setStatusFilter(status) {
            if (process.env.NODE_ENV !== 'production') {
                console.info(
                    '[PublisherMaterialRequestsAdminPage.setStatusFilter] →',
                    status
                );
            }
            this.$store.commit('SET_ADMIN_MATERIAL_REQUESTS_FILTERS', {
                status,
            });
            this.$store.commit('SET_ADMIN_MATERIAL_REQUESTS_PAGE', 1);
            await this.$store.dispatch('loadAdminMaterialRequests');
        },
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
            <hr class="left-separator" />

            <label class="chapter_header">Filter by Status</label>

            <button
                @click="setStatusFilter(null)"
                :class="{ active: !statusFilters.status }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">All Requests</label>
            </button>

            <button
                @click="setStatusFilter(constants.MATERIAL_REQUEST_STATUS.NEW)"
                :class="{
                    active:
                        statusFilters.status ===
                        constants.MATERIAL_REQUEST_STATUS.NEW,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">New</label>
            </button>

            <button
                @click="
                    setStatusFilter(
                        constants.MATERIAL_REQUEST_STATUS.IN_PROGRESS
                    )
                "
                :class="{
                    active:
                        statusFilters.status ===
                        constants.MATERIAL_REQUEST_STATUS.IN_PROGRESS,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">In Progress</label>
            </button>

            <button
                @click="setStatusFilter(constants.MATERIAL_REQUEST_STATUS.DONE)"
                :class="{
                    active:
                        statusFilters.status ===
                        constants.MATERIAL_REQUEST_STATUS.DONE,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Done</label>
            </button>

            <button
                @click="
                    setStatusFilter(constants.MATERIAL_REQUEST_STATUS.REJECTED)
                "
                :class="{
                    active:
                        statusFilters.status ===
                        constants.MATERIAL_REQUEST_STATUS.REJECTED,
                }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Rejected</label>
            </button>
        </LeftPanel>

        <RightContainer>
            <div class="right_container_block">
                <div class="right_header">
                    <label>Material Requests</label>
                </div>
                <hr class="section_hr" />
                <MaterialRequestsAdminList />
            </div>
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.right_container_block {
    padding: 20px;
}

.right_header {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
}

.section_hr {
    margin: 0 0 20px;
    border: none;
    border-top: 1px solid var(--border-color);
}

/* Active left panel button */
.left_button_main_container.active {
    background-color: var(--main-color);
    color: white;
}
</style>
